/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import LoginTeaser from "../../LoginTeaser/LoginTeaser";
import Grid from "@mui/material/Grid";
import PartnersSection from "../../_Sections/PartnersSection/PartnersSection";
import { Avatar, Box, Divider, List, ListItem, ListItemAvatar, ListItemText, Paper } from "@mui/material";
import NavigationBar from "../../NavigationBar/NavigationBar";
import NavigationBarMobile from "../../../mobileComponents/NavigationBar/NavigationBar";
import { Link, Navigate } from "react-router-dom";
import {
  BuildOutlined,
  CalendarTodayOutlined,
  CategoryOutlined,
  ListOutlined,
  PersonAddOutlined,
} from "@mui/icons-material";
import { isMobile } from "react-device-detect";
import GlobalProvider from "../../Provider/GlobalProvider";
import ExternalsDashboardPage from "../ExternalsPages/ExternalsDashboardPage/ExternalsDashboardPage";
import { userHasRole } from "../../../services/backofficeUserService";
import { Roles } from "../../../types/BackofficeUser";
import CreateCasePage from "../CreateCasePage/CreateCasePage";
import LayoutDeviceBased from "../../../routeHelperComponents/LayoutDeviceBased";
import homePageStyles from "./homePageStyle";
import LoginPageBackgroundWrapper from "../../LoginPageBackground/LoginPageBackgroundWrapper";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import React from "react";

const HomePage = ({}) => {
  const currentUser = useCurrentUser();

  if (userHasRole(currentUser, Roles.callcenter)) {
    return (
      <LayoutDeviceBased>
        <CreateCasePage />
      </LayoutDeviceBased>
    );
  }

  if (currentUser.isExternal) {
    return <ExternalsDashboardPage />;
  }

  if (userHasRole(currentUser, Roles.lawyer)) {
    return <Navigate to={"/services/dashboard/anwalt"} />;
  }

  return (
    <GlobalProvider>
      <LoginPageBackgroundWrapper>
        {isMobile ? <NavigationBarMobile /> : <NavigationBar />}
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "center"
          }}>
          {!isMobile && (
            <Grid
              size={{
                xs: 12,
                sm: 5
              }}>
              <LoginTeaser />
            </Grid>
          )}
          <Grid
            sx={homePageStyles.listContainer}
            size={{
              xs: 12,
              sm: 3
            }}>
            <Paper>
              <List>
                <ListItem alignItems="flex-start" component={Link} to={"/services/aktivitaeten"}>
                  <ListItemAvatar>
                    <Avatar>
                      <ListOutlined />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Box sx={homePageStyles.listItemTitle}>Aktivitäten</Box>}
                    secondary={
                      <>
                        <Box component="span" sx={homePageStyles.bold}>
                          Was gibt es zu tun?
                        </Box>{" "}
                        — Hier siehst Du deine Aktivitäten für den Tag, die Woche, etc.
                      </>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem alignItems="flex-start" component={Link} to={"/services/fristenkalender"}>
                  <ListItemAvatar>
                    <Avatar>
                      <CalendarTodayOutlined />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Box sx={homePageStyles.listItemTitle}>Fristen</Box>}
                    secondary={
                      <>
                        <Box component="span" sx={homePageStyles.bold}>
                          Nichts verpassen
                        </Box>{" "}
                        — Alle wichtigen Fristen im Überblick
                      </>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem alignItems="flex-start" component={Link} to={"/services/tools/mandant-anlegen"}>
                  <ListItemAvatar>
                    <Avatar>
                      <PersonAddOutlined />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Box sx={homePageStyles.listItemTitle}>Neuer Fall</Box>}
                    secondary={
                      <>
                        <Box component="span" sx={homePageStyles.bold}>
                          Mandantschaft anlegen
                        </Box>{" "}
                        — hier kann eine neue Mandantschaft hinzugefügt werden
                      </>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem alignItems="flex-start" component={Link} to={"/services/board/uebersicht"}>
                  <ListItemAvatar>
                    <Avatar>
                      <CategoryOutlined />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Box sx={homePageStyles.listItemTitle}>Produkte</Box>}
                    secondary={
                      <>
                        <Box component="span" sx={homePageStyles.bold}>
                          Zu den Rechtsprodukt-Boards
                        </Box>{" "}
                        — hier siehst Du alle Legalbird-Produkte
                      </>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem alignItems="flex-start" component={Link} to={"/services/tools"}>
                  <ListItemAvatar>
                    <Avatar>
                      <BuildOutlined />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Box sx={homePageStyles.listItemTitle}>Tools</Box>}
                    secondary={
                      <>
                        <Box component="span" sx={homePageStyles.bold}>
                          Unsere kleinen Helfer
                        </Box>{" "}
                        — Bußgeldrechner, VKHs prüfen und vieles mehr
                      </>
                    }
                  />
                </ListItem>
              </List>
            </Paper>
          </Grid>
          <Grid size={12}>
            <PartnersSection />
          </Grid>
        </Grid>
      </LoginPageBackgroundWrapper>
    </GlobalProvider>
  );
};

export default HomePage;
